<cmps-wait-status *ngIf="state?.pending"></cmps-wait-status>

<ng-container *ngIf="!state?.pending && state?.payload != null">
    <div class="text-right d-print-none">
        <button
            type="button"
            class="btn btn-primary"
            [attr.aria-label]="i18n._7210_PRINT | translate"
            [ngbTooltip]="i18n._7210_PRINT | translate"
            placement="left"
            (click)="onPrintClick()"
        >
            <cmps-icon svgIcon="printer"></cmps-icon>
        </button>
    </div>

    <div>
        <span class="heading">{{ i18n._53_NAME | translate }}:</span>
        <span> {{ name }}</span>
    </div>

    <div>
        <span class="heading">{{ i18n._48_MANAGER | translate }}:</span>
        <span> {{ manager }}</span>
    </div>

    <div>
        <span class="heading">{{ i18n._201_QUARTER | translate }}:</span>
        <span> {{ quarter }}</span>
    </div>

    <div class="mb-3">
        <span class="heading">{{ i18n._965_DATE | translate }}:</span>
        <span> {{ lastModified | cmpsDate: 'y-MM-dd h:mm a' }}</span>
    </div>

    <div class="heading">{{ 'form_lookingBackLabel' | translate }}</div>
    <div
        class="mb-3"
        [innerText]="state?.payload?.lookingBack"
    ></div>

    <div class="heading">{{ 'form_lookingForwardLabel' | translate }}</div>
    <div
        class="mb-3"
        [innerText]="state?.payload?.lookingForward"
    ></div>

    <div class="heading">{{ 'form_conversationSummaryLabel' | translate }}</div>
    <div
        class="mb-3"
        [innerText]="state?.payload?.conversationSummary"
    ></div>
</ng-container>
